import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';

  
  const __default__ = {
    name: 'LabelledInput',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: { type: String, required: true, default: 'text' },
    value: { type: [String, null], required: false },
    label: { type: String, required: true, default: 'Input' },
    labelColor: { type: String, required: true, default: '#000' },
    backgroundColor: { type: String, required: true, default: '#f8f8f8' },
    labelOpacity: { type: String, required: true, default: '1' }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'input', value: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { type: string, value?: string | null, label: string, labelColor: string, backgroundColor: string, labelOpacity: string };

  

  

  function handleInput(e: KeyboardEvent) {
    emits('input', (e.target as HTMLInputElement).value);
  }

return { __sfc: true,emits, props, handleInput, BaseText }
}

})